module.exports = __webpack_public_path__ + "static/annuities-hero-mobile.41fa70d8.webp";